import { schema } from 'normalizr';

export const sessionSchema = new schema.Entity('sessions', {}, { idAttribute: 'SessionId' });

export const sessionListSchema = [sessionSchema];
